import type {
  DeleteAccountRequest,
  UpdateProfileEmailRequest,
  UpdateProfileNameRequest,
  UpdateProfileUsernameRequest,
  VerifyAccountEmailCodeRequest,
  VerifyPhoneCodeRequest,
} from "@vetty/contracts";
import { apiPaths } from "./paths";
import { requireDelete, requirePost, requirePut, type SdkRequest } from "./request";

export const getCurrentUser = (request: SdkRequest) =>
  request.get(apiPaths.accounts.me());

export const deleteCurrentUser = (
  request: SdkRequest,
  body?: DeleteAccountRequest,
) => requireDelete(request)(apiPaths.accounts.me(), { data: body ?? {} });

export const updateProfileName = (
  request: SdkRequest,
  body: UpdateProfileNameRequest,
) => requirePut(request)(apiPaths.accounts.name(), body);

export const updateProfileEmail = (
  request: SdkRequest,
  body: UpdateProfileEmailRequest,
) => requirePut(request)(apiPaths.accounts.email(), body);

export const updateProfileUsername = (
  request: SdkRequest,
  body: UpdateProfileUsernameRequest,
) => requirePut(request)(apiPaths.accounts.username(), body);

export const verifyAccountPhone = (
  request: SdkRequest,
  body: VerifyPhoneCodeRequest,
) => requirePost(request)(apiPaths.accounts.phoneVerify(), body);

export const sendAccountEmailVerification = (request: SdkRequest) =>
  requirePost(request)(apiPaths.accounts.emailSendVerification());

export const verifyAccountEmailCode = (
  request: SdkRequest,
  body: VerifyAccountEmailCodeRequest,
) => requirePost(request)(apiPaths.accounts.emailVerifyCode(), body);

export const uploadAvatar = (request: SdkRequest, formData: unknown) =>
  requirePost(request)(apiPaths.accounts.avatar(), formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const deleteAvatar = (request: SdkRequest) =>
  requireDelete(request)(apiPaths.accounts.avatar());

export const completeOnboarding = (request: SdkRequest) =>
  requirePost(request)(apiPaths.accounts.onboardingComplete());
